import { isWhatsAppMediaForFreeForm, isWhatsAppMediaForTemplate } from '@/constants/whatsAppMimeTypes.js';

export const RESTRICT_CONTENT = {
    ALL_FILES: 0,
    WHATSAPP_MEDIA_FOR_TEMPLATE: 1,
    WHATSAPP_MEDIA_FOR_FREE_FORM: 2
};

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

const MAX_IMAGE_SIZE = 20 * 1024 * 1024;   // 20 MB
// const MAX_VIDEO_SIZE = 40 * 1024 * 1024;   // 40 MB
const MAX_VIDEO_SIZE = 20 * 1024 * 1024;   // 20 MB
const MAX_AUDIO_SIZE = 20 * 1024 * 1024;   // 20 MB
const MAX_DOCUMENT_SIZE = 20 * 1024 * 1024;   // 20 MB

export const filesMixin = {
    props: {
        establishment: {
            type: Object,
        },
        restrictContent: {
            type: Number,
            default: RESTRICT_CONTENT.ALL_FILES,
            validator: (value) => Object.values(RESTRICT_CONTENT).includes(value)
        },
    },
    data: function() {
        return {
            acceptedFileTypes: ".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.mp4,.mp3,.m4a,.ogg",
            uploadError: null,
            currentStatus: null,
            updating: false,
            error: false,
            success: false,
            infoMessage: "",
            uploadFieldName: 'files',
        };
    },
    computed: {
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        },
        getFiles: function() {
            return this.establishment.preferences.files.filter(file => {
                switch (this.restrictContent) {
                    case RESTRICT_CONTENT.WHATSAPP_MEDIA_FOR_TEMPLATE:
                        return isWhatsAppMediaForTemplate(file);
                    case RESTRICT_CONTENT.WHATSAPP_MEDIA_FOR_FREE_FORM:
                        return isWhatsAppMediaForFreeForm(file);
                    default:
                        return true;
                }
        });
        },
    },
    methods: {
        reset: function() {
            // reset form to initial state
            this.currentStatus = STATUS_INITIAL;
            this.infoMessage = null;
        },
        saveFiles: function(formData) {
            // upload data to the server
            this.currentStatus = STATUS_SAVING;

            this.$http.post('/guest-management/v1/establishments/' + this.establishment.reference + '/files/upload', formData)
                .then(response => {
                    console.log("Files uploaded:");
                    console.log(response);
                    this.currentStatus = STATUS_SUCCESS;
                    const images = response.data;
                    this.establishment.preferences.files.push(...images);
                    for (let image of images) {
                        if (image.type && image.type.startsWith('image')) {
                            this.establishment.preferences.images.push(...images);
                        }
                    }
                    this.$root.$emit("uploaded-files", images);
                    setTimeout(() => {
                        this.reset();
                    }, 3000);
                }).catch(error => {
                    this.currentStatus = STATUS_FAILED;
                    if (error.response) {
                        if (error.response.status === 413) {
                            this.uploadError = "Error - file too large. Please try again."
                        } else {
                            this.uploadError = "Error: " + error.response.data.message
                        }
                    } else {
                        this.uploadError = "Error uploading images";
                    }
                });
        },
        filesChange: function(fieldName, fileList) {
            // handle file changes
            const formData = new FormData();

            if (!fileList.length) {
                return;
            }

            for (const file of fileList) {
                if (file.type.startsWith("image/") && file.size > MAX_IMAGE_SIZE) {
                    this.currentStatus = STATUS_FAILED;
                    this.uploadError = `${file.name} is ` + this.friendlyFileSize(file.size) + `. The limit is 20MB for images.`;
                    return;
                } else if (file.type.startsWith("video/") && file.size > MAX_VIDEO_SIZE) {
                    this.currentStatus = STATUS_FAILED;
                    this.uploadError = `${file.name} is ` + this.friendlyFileSize(file.size) + `. The limit is 20MB for videos.`;
                    return;
                } else if (file.type.startsWith("audio/") && file.size > MAX_AUDIO_SIZE) {
                    this.currentStatus = STATUS_FAILED;
                    this.uploadError = `${file.name} is ` + this.friendlyFileSize(file.size) + `. The limit is 20MB for audio.`;
                    return;
                } else if (file.type.startsWith("application/") && file.size > MAX_DOCUMENT_SIZE) {
                    this.currentStatus = STATUS_FAILED;
                    this.uploadError = `${file.name} is ` + this.friendlyFileSize(file.size) + `. The limit is 20MB for documents.`;
                    return;
                } else if (file.size > MAX_DOCUMENT_SIZE) {
                    this.currentStatus = STATUS_FAILED;
                    this.uploadError = `${file.name} is ` + this.friendlyFileSize(file.size) + `. The limit is 20MB for documents.`;
                    return;
                }
            }

            // append the files to FormData
            Array.from(Array(fileList.length).keys())
                    .map(x => {
                        formData.append(fieldName, fileList[x], fileList[x].name);
                    });

            // save it
            this.saveFiles(formData);
        },
        isImage: function(file) {
            if (file.type && file.type.startsWith('image')) {
                return true;
            } else {
                return false;
            }
        },
        isVideo: function(file) {
            if (file.type && file.type.startsWith('video')) {
                return true;
            } else {
                return false;
            }
        },
        isAudio: function(file) {
            if (file.type && file.type.startsWith('audio')) {
                return true;
            } else {
                return false;
            }
        },
        getMediaFileNameFromURL(url) {
            const baseUrl = url.split("?")[0];
            const filename = baseUrl.split("/").pop();
            return filename;
        },
        friendlyFileSize: function (size) {
            if (size < 1024) {
                return size + " B";
            } else if (size < 1024 * 1024) {
                return (size / 1024).toFixed(2) + " KB";
            } else if (size < 1024 * 1024 * 1024) {
                return (size / (1024 * 1024)).toFixed(2) + " MB";
            } else {
                return (size / (1024 * 1024 * 1024)).toFixed(2) + " GB";
            }
        },
    },
};